module.exports = __webpack_public_path__ + "img/thumbnail.c8c8aa0d.jpg";